var exports = {
  "g4": "MyProfileTab.module__loadingContainer___c0lfUG",
  "MT": "MyProfileTab.module__contentLayout___c0lfUG",
  "v$": "MyProfileTab.module__formColumn___c0lfUG",
  "c9": "MyProfileTab.module__inputFooter___c0lfUG",
  "fU": "MyProfileTab.module__opacityHalf___c0lfUG",
  "Bo": "MyProfileTab.module__previewColumn___c0lfUG",
  "sM": "MyProfileTab.module__srOnly___c0lfUG",
};

module.exports = exports;
